import type { CloseButtonProps as _CloseButtonProps } from "@chakra-ui/react";
import { forwardRef, CloseButton as _CloseButton } from "@chakra-ui/react";

export interface CloseButtonProps extends _CloseButtonProps {}

export const CloseButton = forwardRef<CloseButtonProps, "button">(({ ...props }, ref) => (
    <_CloseButton ref={ref} {...props} />
));
